import store from '../store/store';
export default function isSearchBoxEmpty() {
    return store.searchText.trim().length === 0 && store.suggestionPillIds.length === 0;
}
//# sourceMappingURL=isSearchBoxEmpty.js.map